import { useEffect, useState } from 'react'
import { Box } from '@material-ui/core'
import { useForm } from 'react-final-form'
import { FieldArray } from 'react-final-form-arrays'
import useWebService from '../../../../services/web/useWebService'
import Accordion from '../../../../control/accordion/accordion'
import DocumentTopicField from './documentTopicField'
import { DocumentTopic } from '../../../../services/web/types/requestWebServiceTypes'

export interface DocumentTopicsProps {
    title: string
    irb: number | undefined
    submittedTypeId: number
    isReadOnly?: boolean
    projectDataForm: DocumentTopic[]
}

const DocumentTopics = (props: DocumentTopicsProps) => {
    const { title, irb, submittedTypeId, isReadOnly, projectDataForm } = props

    const webServices = useWebService()
    const form = useForm()

    const [_, setIsLoading] = useState(true)

    const fetchInitialValues = async (irb: number, submittedTypeId: number) => {
        try {
            const { result } = await webServices.getProjectForm(submittedTypeId, irb)
            form.change('form', result)
        } catch (error) {
            console.error(error)
        } finally {
            setIsLoading(false)
        }
    }

    useEffect(() => {
        if (!irb || !submittedTypeId) return

        const documentForm = form.getState().values.form

        if (projectDataForm.length > 0) {
            form.change('form', projectDataForm)
        } else if (!documentForm || !Array.isArray(documentForm) || documentForm.length === 0) {
            fetchInitialValues(irb, submittedTypeId)
        }
    }, [])

    return (
        <FieldArray name="form">
            {({ fields }) => (
                <Accordion title={title}>
                    <Box display="flex" flexDirection="column" width="100%">
                        {fields.map((e, index) => (
                            <DocumentTopicField key={index} name={e} disabled={isReadOnly} />
                        ))}
                    </Box>
                </Accordion>
            )}
        </FieldArray>
    )
}

export default DocumentTopics
